import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconBottle: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="bottle, wine, campaign"><path d="M9.375 1C8.96079 1 8.625 1.33579 8.625 1.75C8.625 2.12162 8.89529 2.43012 9.25 2.48963V6.81217C9.25 6.88194 9.22084 6.94854 9.16957 6.99587L6.56301 9.40193C6.20411 9.73321 6 10.1994 6 10.6878V21.25C6 22.2165 6.7835 23 7.75 23H16.25C17.2165 23 18 22.2165 18 21.25V10.6878C18 10.1994 17.7959 9.73321 17.437 9.40193L14.8304 6.99587C14.7792 6.94854 14.75 6.88194 14.75 6.81217V2.48963C15.1047 2.43012 15.375 2.12162 15.375 1.75C15.375 1.33579 15.0392 1 14.625 1H9.375Z" fill="currentColor"/></CentralIconBase>;
};

export default IconBottle;
